import ReactDOM from "react-dom";
import App from "./Components/Routes/App";

ReactDOM.render(<App />,document.getElementById("wrapper")
);
